<script setup lang="ts">
import { ref } from 'vue'
import { Carousel, Pagination, Slide } from 'vue3-carousel'
import type { PropType } from 'vue'

const props = defineProps<{
  slides: { type: PropType<any[]>; required: true }
}>();

const slides = ref(props.slides)
</script>

<template>
  <section v-if="slides && slides.length" class="section section-slider">
    <div class="slider slider-hero js-slider">
      <div class="slider__clip">
        <div class="slider__slides">
          <Carousel v-if="slides.length > 1">
            <Slide class="slider__slide" v-for="(slide, index) in slides" :key="index">
              <div class="hero">
                <div class="hero__image">
                  <NuxtImg loading="lazy" format="webp" height="550" :src="slide?.sliderImage?.url" :alt="(slide?.heroSliderTitle?.length ?? 0) > 0 ? slide.heroSliderTitle : ''"></NuxtImg>
                </div><!-- /.hero__image -->

                <div class="hero__content">
                  <div class="container">
                    <div class="hero__content-inner">
                      <div class="hero__inner-content">
                        <h1 v-if="(slide?.heroSliderTitle?.length ?? 0) > 0"> {{ slide.heroSliderTitle }} </h1>

                        <p v-if="(slide?.heroSliderText?.length ?? 0) > 0">{{
                            slide.heroSliderText
                          }}</p>

                        <a v-if="(slide?.sliderButton?.url?.length ?? 0) > 0" :href="slide?.sliderButton?.url" class="btn btn-default btn-light btn-icon btn-large">
                          <i class="ico-gift">
                            <svg width="23" height="21" viewBox="0 0 23 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M8.56 0.929729C6.67 0.919729 4.83 2.73973 5.67 4.99973H2.5C1.96957 4.99973 1.46086 5.21044 1.08579 5.58552C0.710714 5.96059 0.5 6.4693 0.5 6.99973V8.99973C0.5 9.26495 0.605357 9.5193 0.792893 9.70683C0.98043 9.89437 1.23478 9.99973 1.5 9.99973H10.5V6.99973H12.5V9.99973H21.5C21.7652 9.99973 22.0196 9.89437 22.2071 9.70683C22.3946 9.5193 22.5 9.26495 22.5 8.99973V6.99973C22.5 6.4693 22.2893 5.96059 21.9142 5.58552C21.5391 5.21044 21.0304 4.99973 20.5 4.99973H17.33C18.5 1.72973 14.1 -0.580271 12.07 2.23973L11.5 2.99973L10.93 2.21973C10.3 1.32973 9.43 0.939729 8.56 0.929729ZM8.5 2.99973C9.39 2.99973 9.84 4.07973 9.21 4.70973C8.58 5.33973 7.5 4.88973 7.5 3.99973C7.5 3.73451 7.60536 3.48016 7.79289 3.29262C7.98043 3.10509 8.23478 2.99973 8.5 2.99973ZM14.5 2.99973C15.39 2.99973 15.84 4.07973 15.21 4.70973C14.58 5.33973 13.5 4.88973 13.5 3.99973C13.5 3.73451 13.6054 3.48016 13.7929 3.29262C13.9804 3.10509 14.2348 2.99973 14.5 2.99973ZM1.5 10.9997V18.9997C1.5 19.5302 1.71071 20.0389 2.08579 20.4139C2.46086 20.789 2.96957 20.9997 3.5 20.9997H19.5C20.0304 20.9997 20.5391 20.789 20.9142 20.4139C21.2893 20.0389 21.5 19.5302 21.5 18.9997V10.9997H12.5V18.9997H10.5V10.9997H1.5Z" fill="currentColor"/>
                            </svg>
                          </i>

                          <span>{{ slide?.sliderButton?.title }}</span>
                        </a>
                      </div><!-- /.hero__inner-content -->
                    </div><!-- /.hero__content-inner -->
                  </div><!-- /.container      -->
                </div><!-- /.hero__content -->
              </div>
            </Slide>

            <template #addons>
              <!-- <Navigation /> -->
              <Pagination v-if="slides.length > 1" />
            </template>
          </Carousel>
          <div class="slider__slide">
            <div class="hero">
              <div class="hero__image">
                <NuxtImg loading="lazy" format="webp" height="550" :src="slides[0]?.sliderImage?.url" :alt="(slides[0]?.heroSliderTitle?.length ?? 0) > 0 ? slides[0].heroSliderTitle : ''"></NuxtImg>
              </div><!-- /.hero__image -->

              <div class="hero__content">
                <div class="container">
                  <div class="hero__content-inner">
                    <div class="hero__inner-content">
                      <h1 v-if="(slides[0]?.heroSliderTitle?.length ?? 0) > 0"> {{ slides[0].heroSliderTitle }} </h1>

                      <p v-if="(slides[0]?.heroSliderText?.length ?? 0) > 0">{{
                          slides[0].heroSliderText
                        }}</p>

                      <a v-if="(slides[0]?.sliderButton?.url?.length ?? 0) > 0" :href="slides[0]?.sliderButton?.url" class="btn btn-default btn-light btn-icon btn-large">
                        <i class="ico-gift">
                          <svg width="23" height="21" viewBox="0 0 23 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8.56 0.929729C6.67 0.919729 4.83 2.73973 5.67 4.99973H2.5C1.96957 4.99973 1.46086 5.21044 1.08579 5.58552C0.710714 5.96059 0.5 6.4693 0.5 6.99973V8.99973C0.5 9.26495 0.605357 9.5193 0.792893 9.70683C0.98043 9.89437 1.23478 9.99973 1.5 9.99973H10.5V6.99973H12.5V9.99973H21.5C21.7652 9.99973 22.0196 9.89437 22.2071 9.70683C22.3946 9.5193 22.5 9.26495 22.5 8.99973V6.99973C22.5 6.4693 22.2893 5.96059 21.9142 5.58552C21.5391 5.21044 21.0304 4.99973 20.5 4.99973H17.33C18.5 1.72973 14.1 -0.580271 12.07 2.23973L11.5 2.99973L10.93 2.21973C10.3 1.32973 9.43 0.939729 8.56 0.929729ZM8.5 2.99973C9.39 2.99973 9.84 4.07973 9.21 4.70973C8.58 5.33973 7.5 4.88973 7.5 3.99973C7.5 3.73451 7.60536 3.48016 7.79289 3.29262C7.98043 3.10509 8.23478 2.99973 8.5 2.99973ZM14.5 2.99973C15.39 2.99973 15.84 4.07973 15.21 4.70973C14.58 5.33973 13.5 4.88973 13.5 3.99973C13.5 3.73451 13.6054 3.48016 13.7929 3.29262C13.9804 3.10509 14.2348 2.99973 14.5 2.99973ZM1.5 10.9997V18.9997C1.5 19.5302 1.71071 20.0389 2.08579 20.4139C2.46086 20.789 2.96957 20.9997 3.5 20.9997H19.5C20.0304 20.9997 20.5391 20.789 20.9142 20.4139C21.2893 20.0389 21.5 19.5302 21.5 18.9997V10.9997H12.5V18.9997H10.5V10.9997H1.5Z" fill="currentColor"/>
                          </svg>
                        </i>

                        <span>{{ slides[0]?.sliderButton?.title }}</span>
                      </a>
                    </div><!-- /.hero__inner-content -->
                  </div><!-- /.hero__content-inner -->
                </div><!-- /.container      -->
              </div><!-- /.hero__content -->
            </div>
          </div>
        </div><!-- /.slider__slides -->
      </div><!-- /.slider__clip -->
    </div><!-- /.slider js-slider -->
  </section>
</template>

<style>
.slider__slide {
  width: 100%;
  align-items: center;
}

.carousel__prev,
.carousel__next {
  box-sizing: content-box;
  border: 5px solid white;
}
</style>
